import { Link } from "react-router-dom";

const FormsFooter = ({ classes }) => {
  return (
    <footer className={classes.footer}>
      <p className="mb-0">
        EasyNotification® è un marchio registrato di proprietà di Progetti e
        Soluzioni SpA
      </p>
      <Link to="/Informativa_Privacy.pdf" target="_blank">
        Privacy
      </Link>
    </footer>
  );
};

export default FormsFooter;
